import isNotObject from './isNotObject';

/**
 * @public
 * Removes `null` and `undefined` values from an `Object` or `Array`
 *
 * @see https://gist.github.com/jherax/678090a964875f7c3539
 *
 * @param  {Object|Array} obj: the object to where remove the empty values
 * @return {any}
 */
export default function removeEmpty(obj) {
  if (isNotObject(obj)) return obj;
  if (obj instanceof Array) {
    for (let i = 0; i < obj.length; i += 1) {
      if (obj[i] == null) obj.splice(i--, 1); // eslint-disable-line
      else removeEmpty(obj[i]);
    }
  } else {
    for (const p in obj) {
      if (obj[p] == null) delete obj[p];
      else removeEmpty(obj[p]);
    }
  }
  return obj;
}
